import Portal from "@/managers/portal"
import Tracking from "@/managers/session/logging/tracking"
import AuthenticationMethodBase from "@/managers/authentication/authenticationMethodBase"

class UsernamePassword extends AuthenticationMethodBase {
	constructor() {
		super(true)
	}

	public async login(username: string, password: string): Promise<void> {
		if (!this.canLogin)
			throw new Error("Can't login now")

		this.setLoggingIn()
		try {
			await Portal.call.sessions.passwordLoginPost(username, password).response
		} finally {
			this.setCanLogin(true)
		}
	}

	public async requestReset(username: string): Promise<void> {
		Tracking.event("Authentication", "Request reset")
		return Portal.call.passwords.requestResetPasswordPost(username).response
	}

	public async reset(ticketId: string, newPassword: string): Promise<void> {
		Tracking.event("Authentication", "Reset")
		return Portal.call.passwords.post(ticketId, newPassword).response
	}
}

export default new UsernamePassword()
